console.log("single-workshop 3 - v1.1");
jQuery(function ($) {

    if (jQuery('#frm_form_45_container').length > 0) {

        // Populate date select field
        let SelectedDates = document.querySelector("#field_c5nnr");
        SelectedDates.innerHTML = "";
        SelectedDates.innerHTML += `<option selected="selected" value="Option 1"></option>`
        //console.log(dl_dates);
        dl_dates.forEach(o => {
            console.log(o);
            let dateObj = `${o.id}_${o.hour}_${o.dateId}`;
            if (o.isFull == true) {
                SelectedDates.innerHTML += `<option data-id="${dateObj}" value="${o.dia}T${o.hora}" data-title="${o.title}" disabled >${o.date} - ${o.title} - FULL/CLOSED</option>`;
            } else {
                SelectedDates.innerHTML += `<option data-id="${dateObj}" value="${o.dia}T${o.hora}" data-title="${o.title}" >${o.date} - ${o.title}</option>`;
            }
        });
        document.querySelector("#field_c5nnr").addEventListener('change', e => {
            document.querySelector('#field_workshop_id').value = document.querySelector("#field_c5nnr").selectedOptions[0].attributes[0].value;
            document.querySelector('#field_ws_location').value = document.querySelector("#field_c5nnr").selectedOptions[0].attributes['data-title'].value;
        })
        //document.querySelector("#field_j9067").selectedOptions[0].attributes[0].value


        // Add Google Address api to address field
        //seleccionar por defecto pais de Estados unidos en formulario
        // let select = document.querySelector('#field_enklt_country');
        //document.querySelector("#field_7l17z").selectedOptions[0].attributes[0].value
        // select.selectedOptions[0].attributes[0].value = 'United States';
        //United States
        //United States
        //console.log(select.selectedOptions[0].attributes[0].value);

        //input
        let inputSearch = document.querySelector('#field_s9tof');
        let inputCity = document.querySelector('#field_zmlg9');
        let inputState = document.querySelector('#field_2zhu0');
        let inputPostalCode = document.querySelector('#field_70yz8');
        const initAutocomplete = () => {
            console.log("google search");
            autocomplete = new google.maps.places.Autocomplete(inputSearch, {
                componentRestrictions: { country: ["us"] },
                fields: ["address_components", "geometry"]
            });
            autocomplete.addListener("place_changed", fillInAddress);
        }

        const fillInAddress = () => {
            let city = '';
            let state = '';
            let postcode = '';
            let streetNumber = '';
            let route = '';
            let locality = '';
            let address = '';
            const place = autocomplete.getPlace();
            console.log(place);
            place.address_components.forEach(e => {
                const componentType = e.types[0];
                switch (componentType) {
                    case "street_number": {
                        streetNumber = `${e.long_name} `;
                        break;
                    }
                    case "route": {
                        route = `${e.long_name} `;
                        break;
                    }
                    case "postal_code": {
                        postcode = `${e.long_name}${postcode}`;
                        break;
                    }
                    case "postal_code_suffix": {
                        postcode = `${postcode}-${e.long_name}`;
                        break;
                    }
                    case "administrative_area_level_1": {
                        state = e.long_name;
                        break;
                    }
                    case "locality": {
                        city = e.long_name;
                        break;
                    }
                    default:
                        break;
                }
                address = `${streetNumber}${route}`;
            });
            inputSearch.value = address;
            inputCity.value = city;
            inputState.value = state;
            inputPostalCode.value = postcode;
            console.log();
        }
        initAutocomplete();
        let valores = window.location.search;
        const urlParams = new URLSearchParams(valores);
        utm_source = "";
        utm_source_cookie = getCookie("utm_source");
        if (utm_source_cookie) {
            console.log("cookie ya existe, valor es: " + utm_source_cookie);
            utm_source = utm_source_cookie;
        }

        let utm_source_param = urlParams.get('utm_source');
        let is_ga_landing = false;
        if (/workshop-registration/.test(window.location.href)) {
            is_ga_landing = true;
            utm_source_param = "google";
        }
        if (utm_source_param || is_ga_landing) {
            console.log("parametro de cookie existe, se crea, o si ya existe se sobreescribe");
            document.cookie = "utm_source=" + utm_source_param + "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
            utm_source = utm_source_param;
        }



        if (utm_source) {
            console.log("utm_source final: " + utm_source);
            document.querySelector('#field_utm_source').value = utm_source;
            if (utm_source == 'adds' || utm_source == 'google' || utm_source == 'adwords') {
                document.querySelector('#field_edm2r').value = "Google Adwords";
            }

            if (utm_source == 'carta' || utm_source == 'letter') {
                document.querySelector('#field_edm2r').value = "NCOT Letter";
            }
        } else {
            console.log("utm source is empty or non existant.");
        }

    }

    function getCookie(cookieName) {
        let name = cookieName + "=";
        let spli = document.cookie.split(';');
        for (var j = 0; j < spli.length; j++) {
            let char = spli[j];
            while (char.charAt(0) == ' ') {
                char = char.substring(1);
            }
            if (char.indexOf(name) == 0) {
                return char.substring(name.length, char.length);
            }
        }
        return "";
    }

});